import { register_es_version } from "../../multi_import_deduplicator.mjs";
register_es_version("ui/locales", "ES10");
/**
 * Exported naming follows IETF BCP 47: https://en.wikipedia.org/wiki/IETF_language_tag
 * Due to the way we handle locales in the backend, we also export one version of each language with the country code appended. That version will automatically select that version of locale in the backend (where they sometimes have country codes). Let us know if one is missing and we'll add it.
 */
const $3ae9d5d3dda72bac$var$english_base_translation = {
  backend_locale_: "",
  // Set to empty string to pass type validation here. We add these where we export the locales in index.ts since the language parts are very much the same right now.
  "of_": "of",
  "sorting_text_": "Sort",
  "filter_text_": "Filter",
  "filters_": "Filters",
  "clear_all_from_filter_crumbs_": "Clear all",
  "clear_all_filters_from_big_button_": "Clear all filters",
  "view_more_": "View more",
  "view_less_": "View less",
  "selected_filters_title_": "Filters",
  "try_without_filters_": "Try again without filters",
  "clear_individual_filter_": "Clear",
  range_filter_low_point_aria_label_: "Range filter lower value",
  range_filter_high_point_aria_label_: "Range filter higher value",
  morphing_sign_expanded_aria_label_: "Collapse section",
  morphing_sign_collapsed_aria_label_: "Expand section",
  close_: "Close",
  ok_: "OK",
  filters_cleared_: "Filters cleared",
  we_cleared_your_filters_: "We cleared your filters",
  restore_: "Restore",
  open_sorting_: "Open sorting",
  close_sorting_: "Close sorting",
  open_filters_: "Open filters",
  close_filters_: "Close filters",
  back_: "Back",
  scroll_to_top_: "Scroll to top",
  search_a_filter_: section => "Search ".concat(section.toLowerCase()),
  breadcrumbs_aria_label_: "Breadcrumbs",
  breadcrumbs_separator_: "/",
  /** Fallback price formatting */price_formatting_: {
    pre_: "",
    post_: "",
    decimal_places_delimiter_: ".",
    thousands_delimiter_: ",",
    places_after_comma_: 2
  }
};
const $3ae9d5d3dda72bac$export$61b15fe6451cdba0 = {
  ...$3ae9d5d3dda72bac$var$english_base_translation,
  show_n_products_: number_of_results => ["Show ", number_of_results, " products"],
  no_products_text_: "No products here, sorry",
  product_: "product",
  products_: "products",
  quicklinks_aria_label_: "Categories"
};
const $3ae9d5d3dda72bac$export$434b5d2e9cbbcde1 = {
  ...$3ae9d5d3dda72bac$var$english_base_translation,
  show_n_results_: number_of_results => ["Show ", number_of_results, " result(s)"],
  modal_view_all_results_: number_of_results => ["View all ", number_of_results, " result(s)"],
  "search_recs_title_": "Other alternatives",
  "category_": "Category",
  "brand_": "Brand",
  "modal_discover_more_": "Discover more",
  "previous_searches_text_": "Your previous searches",
  "suggestions_": "Suggestions",
  "no_results_text_": "No results",
  "clear_filters_query_sorting_after_submit_": "Clear query. Also clear sorting and filters after next submit.",
  "placeholder_text_": "Search",
  "no_products_": "No products found",
  "content_": "Content",
  search_submit_button_aria_label_: "Search",
  search_field_field_aria_label_: "Search query field",
  previous_searches_delete_entry_from_history_: "Remove query from history",
  listing_suggestions_: "Categories & Collections",
  previous_: "Previous",
  popular_: "Popular",
  products_: "Products",
  get_showing_results_for_: (query, number_of_results_element, has_query, number_of_results) => {
    const product_form = number_of_results === 1 ? "product" : "products";
    return has_query ? ["Showing ", number_of_results_element, " ".concat(product_form, " for "), query] : ["Showing all ", number_of_results_element, " ".concat(product_form)];
  },
  get_showing_pages_for_: (query, number_of_results_element, has_query, number_of_results) => {
    const page_form = number_of_results === 1 ? "page" : "pages";
    return has_query ? ["Found ", number_of_results_element, " ".concat(page_form, " for "), query] : ["Found ", number_of_results_element, " ".concat(page_form)];
  },
  modal_view_all_no_results_: "View alternatives"
};
const $6364f832d4df5198$var$czech_base_translation = {
  "of_": "z",
  "sorting_text_": "T\u0159\xeddit",
  "filter_text_": "Filtr",
  "filters_": "Filtry",
  "clear_all_from_filter_crumbs_": "Vymazat v\u0161e",
  "clear_all_filters_from_big_button_": "Vymazat v\u0161echny filtry",
  "view_more_": "Zobrazit v\xedce",
  "view_less_": "Zobrazit m\xe9n\u011B",
  "selected_filters_title_": "Filtry",
  "try_without_filters_": "Zkusit znovu bez filtr\u016F",
  "clear_individual_filter_": "Vymazat",
  "range_filter_low_point_aria_label_": "Doln\xed hodnota rozsahu filtru",
  "range_filter_high_point_aria_label_": "Horn\xed hodnota rozsahu viltru",
  "morphing_sign_expanded_aria_label_": "Sbalit odd\xedl",
  "morphing_sign_collapsed_aria_label_": "Rozbalit odd\xedl",
  close_: "Zav\u0159\xedt",
  ok_: "OK",
  filters_cleared_: "Filtry vy\u010Di\u0161t\u011Bny",
  we_cleared_your_filters_: "Vy\u010Distili jsme va\u0161e filtry",
  restore_: "Obnovit",
  open_sorting_: "Otev\u0159\xedt \u0159azen\xed",
  close_sorting_: "Zav\u0159\xedt \u0159azen\xed",
  open_filters_: "Otev\u0159\xedt filtry",
  close_filters_: "Zav\u0159\xedt filtry",
  back_: "Zp\u011Bt",
  scroll_to_top_: "P\u0159ej\xedt nahoru",
  "breadcrumbs_aria_label_": "Drobe\u010Dkov\xe1 navigace",
  search_a_filter_: section => "Hledat ".concat(section.toLowerCase())
};
const $6364f832d4df5198$export$93916862db74da11 = {
  ...(0, $3ae9d5d3dda72bac$export$61b15fe6451cdba0),
  // fallbacks for untranslated strings
  ...$6364f832d4df5198$var$czech_base_translation,
  show_n_products_: number_of_results => ["Zobrazit ", number_of_results, " v\xfdrobk\u016F"],
  "no_products_text_": "Zde nejsou \u017E\xe1dn\xe9 v\xfdrobky, je n\xe1m l\xedto",
  "product_": "v\xfdrobek",
  "products_": "v\xfdrobky",
  "quicklinks_aria_label_": "Kategorie"
};
const $6364f832d4df5198$export$62ef558576ddaf3d = {
  ...(0, $3ae9d5d3dda72bac$export$434b5d2e9cbbcde1),
  // fallbacks for untranslated strings
  ...$6364f832d4df5198$var$czech_base_translation,
  show_n_results_: number_of_results => ["Zobrazit ", number_of_results, " v\xfdsledek/ky/k\u016F"],
  modal_view_all_results_: number_of_results => ["Zobrazit v\u0161ech(ny) ", number_of_results, " v\xfdsledk\u016F/ky"],
  get_showing_results_for_: (query, number_of_results_element, has_query, number_of_results) => {
    let product_form = "v\xfdrobk\u016F";
    if (number_of_results === 1) product_form = "v\xfdrobek";else if (number_of_results > 1 && number_of_results < 5) product_form = "v\xfdrobky";
    return has_query ? ["Zobrazuje se ", number_of_results_element, " ".concat(product_form, " pro "), query] : ["Zobrazuj\xed se v\u0161echny ", number_of_results_element, " ".concat(product_form)];
  },
  get_showing_pages_for_: (query, number_of_results_element, has_query, number_of_results) => {
    let page_form = "str\xe1nek";
    if (number_of_results === 1) page_form = "str\xe1nka";else if (number_of_results > 1 && number_of_results < 5) page_form = "str\xe1nky";
    return has_query ? ["Nalezeno ", number_of_results_element, " ".concat(page_form, " pro "), query] : ["Nalezeno ", number_of_results_element, " ".concat(page_form)];
  },
  "search_recs_title_": "Dal\u0161\xed mo\u017Enosti",
  "category_": "Kategorie",
  "brand_": "Zna\u010Dka",
  "modal_discover_more_": "Objevte v\xedce",
  "previous_searches_text_": "Va\u0161e p\u0159edchoz\xed hled\xe1n\xed",
  "content_": "Obsah",
  "suggestions_": "N\xe1vrhy",
  "no_results_text_": "\u017D\xe1dn\xe9 v\xfdsledky",
  "no_products_": "\u017D\xe1dn\xe9 produkty nebyly nalezeny",
  "clear_filters_query_sorting_after_submit_": "Vymazat dotaz. Vymazat i t\u0159\xedd\u011Bn\xed a filtry po p\u0159\xed\u0161t\xedm odesl\xe1n\xed.",
  "placeholder_text_": "Hled\xe1n\xed",
  search_submit_button_aria_label_: "Hled\xe1n\xed",
  "search_field_field_aria_label_": "Pol\xed\u010Dko dotazu hled\xe1n\xed",
  "previous_searches_delete_entry_from_history_": "Odebrat dotaz z historie",
  listing_suggestions_: "Kategorie & Kolekce",
  previous_: "P\u0159edchoz\xed",
  popular_: "Popul\xe1rn\xed",
  products_: "Produkty",
  modal_view_all_no_results_: "Zobrazit alternativy"
};
const $d73851348ade03e4$var$danish_base_translation = {
  "of_": "af",
  "sorting_text_": "Sorter",
  "filter_text_": "Filter",
  "filters_": "Filtre",
  "clear_all_from_filter_crumbs_": "Ryd alt",
  "clear_all_filters_from_big_button_": "Ryd alle filtre",
  "view_more_": "Vis mere",
  "view_less_": "Vis mindre",
  "selected_filters_title_": "Filtre",
  "try_without_filters_": "Pr\xf8v igen uden filtre",
  "clear_individual_filter_": "Ryd",
  "range_filter_low_point_aria_label_": "Omr\xe5defiltrets lavere v\xe6rdi",
  "range_filter_high_point_aria_label_": "Omr\xe5defiltrets h\xf8jere v\xe6rdi",
  "morphing_sign_expanded_aria_label_": "Skjul afsnit",
  "morphing_sign_collapsed_aria_label_": "Udvid afsnit",
  close_: "Luk",
  ok_: "OK",
  filters_cleared_: "Filtre ryddet",
  we_cleared_your_filters_: "Vi har ryddet dine filtre",
  restore_: "Gendan",
  open_sorting_: "\xc5ben sortering",
  close_sorting_: "Luk sortering",
  open_filters_: "\xc5bn filtre",
  close_filters_: "Luk filtre",
  back_: "Tilbage",
  scroll_to_top_: "Rul til top",
  "breadcrumbs_aria_label_": "Br\xf8dkrummer",
  search_a_filter_: section => "S\xf8g ".concat(section.toLowerCase())
};
const $d73851348ade03e4$export$f816e22bdb8038e1 = {
  ...(0, $3ae9d5d3dda72bac$export$61b15fe6451cdba0),
  // fallbacks for untranslated strings
  ...$d73851348ade03e4$var$danish_base_translation,
  show_n_products_: number_of_results => ["Vis ", number_of_results, " produkter"],
  "no_products_text_": "Der er ingen produkter her, desv\xe6rre",
  "product_": "produkt",
  "products_": "produkter",
  "quicklinks_aria_label_": "Kategorier"
};
const $d73851348ade03e4$export$70578856b2420b5d = {
  ...(0, $3ae9d5d3dda72bac$export$434b5d2e9cbbcde1),
  // fallbacks for untranslated strings
  ...$d73851348ade03e4$var$danish_base_translation,
  show_n_results_: number_of_results => ["Vis ", number_of_results, " resultat(er)"],
  "clear_filters_query_sorting_after_submit_": "Ryd s\xf8gning. Ryd ogs\xe5 sortering og filtre f\xf8r n\xe6ste fors\xf8g.",
  "no_results_text_": "Ingen resultater",
  modal_view_all_results_: number_of_results => ["Vis alle ", number_of_results, " resultat(er)"],
  "search_recs_title_": "Andre alternativer",
  "category_": "Kategori",
  "brand_": "M\xe6rke",
  "suggestions_": "Forslag",
  "modal_discover_more_": "Opdag mere",
  "previous_searches_text_": "Dine tidligere s\xf8gninger",
  "placeholder_text_": "S\xf8gning",
  "search_submit_button_aria_label_": "S\xf8gning",
  "content_": "Indhold",
  "no_products_": "Ingen produkter fundet",
  "search_field_field_aria_label_": "Felt til s\xf8gning",
  "previous_searches_delete_entry_from_history_": "Fjern foresp\xf8rgsel fra historik",
  listing_suggestions_: "Kategorier & Kollektioner",
  previous_: "Forrige",
  popular_: "Popul\xe6re",
  products_: "Produkter",
  get_showing_results_for_: (query, number_of_results_element, has_query, number_of_results) => {
    const product_form = number_of_results === 1 ? "produkt" : "produkter";
    return has_query ? ["Viser ", number_of_results_element, " ".concat(product_form, " for "), query] : ["Viser alle ", number_of_results_element, " ".concat(product_form)];
  },
  get_showing_pages_for_: (query, number_of_results_element, has_query, number_of_results) => {
    const page_form = number_of_results === 1 ? "side" : "sider";
    return has_query ? ["Fandt ", number_of_results_element, " ".concat(page_form, " for "), query] : ["Fandt ", number_of_results_element, " ".concat(page_form)];
  },
  modal_view_all_no_results_: "Se alternativer"
};
const $368410baba881db8$var$dutch_base_translation = {
  "of_": "van",
  "sorting_text_": "Sorteren",
  "filter_text_": "Filter",
  "filters_": "Filters",
  "clear_all_from_filter_crumbs_": "Alles wissen",
  "clear_all_filters_from_big_button_": "Alle filters wissen",
  "view_more_": "Toon meer",
  "view_less_": "Toon minder",
  "selected_filters_title_": "Filters",
  "try_without_filters_": "Nieuwe poging zonder filters",
  "clear_individual_filter_": "Wissen",
  "range_filter_low_point_aria_label_": "Bereikfilter lagere waarde",
  "range_filter_high_point_aria_label_": "Bereikfilter hogere waarde",
  "morphing_sign_expanded_aria_label_": "Sectie samenvouwen",
  "morphing_sign_collapsed_aria_label_": "Sectie openvouwen",
  close_: "Sluiten",
  ok_: "OK",
  filters_cleared_: "Filters zijn gewist",
  we_cleared_your_filters_: "We hebben u filters gewist",
  restore_: "Herstellen",
  open_sorting_: "Sorteren openen",
  close_sorting_: "Sorteren sluiten",
  open_filters_: "Filters openen",
  close_filters_: "Filters sluiten",
  back_: "Terug",
  scroll_to_top_: "Naar boven scrollen",
  "breadcrumbs_aria_label_": "Kruimelspoor",
  search_a_filter_: section => "Zoeken ".concat(section.toLowerCase())
};
const $368410baba881db8$export$e6614b50d36f30aa = {
  ...(0, $3ae9d5d3dda72bac$export$61b15fe6451cdba0),
  // fallbacks for untranslated strings
  ...$368410baba881db8$var$dutch_base_translation,
  show_n_products_: number_of_results => ["Toon ", number_of_results, " producten"],
  "no_products_text_": "Sorry, hier zijn geen producten",
  "product_": "product",
  "products_": "producten",
  "quicklinks_aria_label_": "Categorie\xebn"
};
const $368410baba881db8$export$5d14584e27bf4bc5 = {
  ...(0, $3ae9d5d3dda72bac$export$434b5d2e9cbbcde1),
  // fallbacks for untranslated strings
  ...$368410baba881db8$var$dutch_base_translation,
  show_n_results_: number_of_results => ["Toon ", number_of_results, " resulta(a)t(en)"],
  modal_view_all_results_: number_of_results => ["Bekijk alle ", number_of_results, " resulta(a)t(en)"],
  get_showing_results_for_: (query, number_of_results_element, has_query, number_of_results) => {
    const product_form = number_of_results === 1 ? "product" : "producten";
    return has_query ? [number_of_results_element, " ".concat(product_form, " voor "), query, " worden getoond"] : ["Alle ", number_of_results_element, " ".concat(product_form, " worden getoond")];
  },
  get_showing_pages_for_: (query, number_of_results_element, has_query, number_of_results) => {
    const page_form = number_of_results === 1 ? "pagina" : "pagina's";
    return has_query ? ["Gevonden ", number_of_results_element, " ".concat(page_form, " voor "), query] : ["Gevonden ", number_of_results_element, " ".concat(page_form)];
  },
  "search_recs_title_": "Andere opties",
  "category_": "Categorie",
  "brand_": "Merk",
  "content_": "Inhoud",
  "no_products_": "Geen producten gevonden",
  "modal_discover_more_": "Ontdek meer",
  "previous_searches_text_": "vorige zoekopdrachten",
  "suggestions_": "Suggesties",
  "no_results_text_": "Geen resultaten",
  "clear_filters_query_sorting_after_submit_": "Zoekopdracht wissen. Wis ook sortering en filters na volgende verzending.",
  "placeholder_text_": "Zoeken",
  search_submit_button_aria_label_: "Zoeken",
  "search_field_field_aria_label_": "Zoeken met zoekveld",
  "previous_searches_delete_entry_from_history_": "Verwijder zoekopdracht uit geschiedenis",
  listing_suggestions_: "Categorie\xebn & Collecties",
  previous_: "Vorige",
  popular_: "Populair",
  products_: "Producten",
  modal_view_all_no_results_: "Bekijk alternatieven"
};
const $5140cb4dc78a083c$var$finnish_base_translation = {
  "of_": "/",
  "sorting_text_": "Lajittele",
  "filter_text_": "Suodata",
  "filters_": "Suodattimet",
  "clear_all_from_filter_crumbs_": "Tyhjenn\xe4",
  "clear_all_filters_from_big_button_": "Poista valinnat",
  "view_more_": "N\xe4yt\xe4 Lis\xe4\xe4",
  "view_less_": "N\xe4yt\xe4 V\xe4hemm\xe4n",
  "selected_filters_title_": "Suodattimet",
  "try_without_filters_": "Hae uudestaan ilman suodattimia",
  "clear_individual_filter_": "Poista valinnat",
  "range_filter_low_point_aria_label_": "Hintasuodattimen alempi arvo",
  "range_filter_high_point_aria_label_": "Hintasuodattimen ylempi arvo",
  "morphing_sign_expanded_aria_label_": "Pienenn\xe4 osio",
  "morphing_sign_collapsed_aria_label_": "Laajenna osio",
  close_: "Sulje",
  ok_: "OK",
  filters_cleared_: "Suodattimet tyhjennetty",
  we_cleared_your_filters_: "Tyhjensimme suodattimesi",
  restore_: "Palauta",
  open_sorting_: "Avaa lajittelu",
  close_sorting_: "Sulje lajittelu",
  open_filters_: "Avaa suodattimet",
  close_filters_: "Sulje suodattimet",
  back_: "Takaisin",
  scroll_to_top_: "Vierit\xe4 yl\xf6s",
  "breadcrumbs_aria_label_": "Murupolut",
  search_a_filter_: section => "Etsi ".concat(section.toLowerCase())
};
const $5140cb4dc78a083c$export$bf7930000f7ad633 = {
  ...(0, $3ae9d5d3dda72bac$export$61b15fe6451cdba0),
  // fallbacks for untranslated strings
  ...$5140cb4dc78a083c$var$finnish_base_translation,
  show_n_products_: number_of_results => ["N\xe4yt\xe4 ", number_of_results, " tuotetta"],
  "no_products_text_": "Valitettavasti t\xe4\xe4ll\xe4 ei ole tuotteita",
  "product_": "tuote",
  "products_": "tuotteet",
  "quicklinks_aria_label_": "Kategoriat"
};
const $5140cb4dc78a083c$export$bb9c5e11b9203620 = {
  ...(0, $3ae9d5d3dda72bac$export$434b5d2e9cbbcde1),
  // fallbacks for untranslated strings
  ...$5140cb4dc78a083c$var$finnish_base_translation,
  show_n_results_: number_of_results => ["N\xe4yt\xe4 kaikki ", number_of_results, " tulosta"],
  "previous_searches_text_": "Aikaisemmat hakusi",
  "suggestions_": "Ehdotukset",
  "no_results_text_": "Ei tuloksia",
  modal_view_all_results_: number_of_results => ["N\xe4yt\xe4 Kaikki ", number_of_results, " tulosta"],
  "clear_filters_query_sorting_after_submit_": "Tyhjenn\xe4 valinnat uuden haun alkaessa",
  "category_": "Kategoria",
  "brand_": "Merkki",
  "modal_discover_more_": "Katso lis\xe4\xe4",
  get_showing_results_for_: (query, number_of_results_element, has_query, number_of_results) => {
    const product_form = number_of_results === 1 ? "tuote" : "tuotetta";
    return has_query ? ["N\xe4ytet\xe4\xe4n ", number_of_results_element, " ".concat(product_form, " haulle "), query] : ["N\xe4ytet\xe4\xe4n kaikki ", number_of_results_element, " ".concat(product_form)];
  },
  get_showing_pages_for_: (query, number_of_results_element, has_query, number_of_results) => {
    const page_form = number_of_results === 1 ? "sivu" : "sivua";
    return has_query ? ["L\xf6ytyi ", number_of_results_element, " ".concat(page_form, " haulle "), query] : ["L\xf6ytyi ", number_of_results_element, " ".concat(page_form)];
  },
  "no_products_": "Tuotteita ei l\xf6ytynyt",
  "search_recs_title_": "Muita vaihtoehtoja",
  "placeholder_text_": "Hae",
  "content_": "Sis\xe4lt\xf6",
  search_submit_button_aria_label_: "Hae",
  "search_field_field_aria_label_": "Hakukentt\xe4",
  "previous_searches_delete_entry_from_history_": "Poista haku historiasta",
  listing_suggestions_: "Kategoriat & Kokoelmat",
  previous_: "Edellinen",
  popular_: "Suosittu",
  products_: "Tuotteet",
  modal_view_all_no_results_: "N\xe4yt\xe4 vaihtoehdot"
};
const $4696ad1afe2a2ee4$var$french_base_translation = {
  "of_": "de",
  "sorting_text_": "Trier",
  "filter_text_": "Filtre",
  "filters_": "Filtres",
  "clear_all_from_filter_crumbs_": "Effacer tout",
  "clear_all_filters_from_big_button_": "Effacer tous les filtres",
  "view_more_": "Afficher plus",
  "view_less_": "Afficher moins",
  "selected_filters_title_": "Filtres",
  "try_without_filters_": "R\xe9essayer sans les filtres",
  "clear_individual_filter_": "Effacer",
  "range_filter_low_point_aria_label_": "Valeur inf\xe9rieure du filtre de la gamme",
  "range_filter_high_point_aria_label_": "Valeur sup\xe9rieure du filtre de la gamme",
  "morphing_sign_expanded_aria_label_": "R\xe9duire la section",
  "morphing_sign_collapsed_aria_label_": "Agrandir la section",
  close_: "Fermer",
  ok_: "OK",
  filters_cleared_: "Filtres effac\xe9s",
  we_cleared_your_filters_: "Nous avons effac\xe9 vos filtres",
  restore_: "Restaurer",
  open_sorting_: "Ouvrir le tri",
  close_sorting_: "Fermer le tri",
  open_filters_: "Ouvrir les filtres",
  close_filters_: "Fermer les filtres",
  back_: "Retour",
  scroll_to_top_: "Faire d\xe9filer vers le haut",
  "breadcrumbs_aria_label_": "Fil d\u2019Ariane",
  search_a_filter_: section => "Rechercher dans \xab\xa0".concat(section, "\xa0\xbb")
};
const $4696ad1afe2a2ee4$export$ef75fbff2e809c9 = {
  ...(0, $3ae9d5d3dda72bac$export$61b15fe6451cdba0),
  // fallbacks for untranslated strings
  ...$4696ad1afe2a2ee4$var$french_base_translation,
  show_n_products_: number_of_results => ["Afficher ", number_of_results, "\xa0articles"],
  "no_products_text_": "Aucun article ici, d\xe9sol\xe9",
  "product_": "article",
  "products_": "articles",
  "quicklinks_aria_label_": "Cat\xe9gories"
};
const $4696ad1afe2a2ee4$export$e608b2bb21ba1862 = {
  ...(0, $3ae9d5d3dda72bac$export$434b5d2e9cbbcde1),
  // fallbacks for untranslated strings
  ...$4696ad1afe2a2ee4$var$french_base_translation,
  show_n_results_: number_of_results => ["Afficher ", number_of_results, "\xa0r\xe9sultat(s)"],
  modal_view_all_results_: number_of_results => ["Afficher les ", number_of_results, "\xa0r\xe9sultats"],
  get_showing_results_for_: (query, number_of_results_element, has_query, number_of_results) => {
    const product_form = number_of_results === 1 ? "produit" : "produits";
    return has_query ? ["Afficher ", number_of_results_element, " ".concat(product_form, " pour "), query] : ["Afficher tous les ", number_of_results_element, " ".concat(product_form)];
  },
  get_showing_pages_for_: (query, number_of_results_element, has_query, number_of_results) => {
    const page_form = number_of_results === 1 ? "page" : "pages";
    return has_query ? ["Trouv\xe9 ", number_of_results_element, " ".concat(page_form, " pour "), query] : ["Trouv\xe9 ", number_of_results_element, " ".concat(page_form)];
  },
  "no_products_": "Aucun produit trouv\xe9",
  "search_recs_title_": "Autres alternatives",
  "category_": "Cat\xe9gorie",
  "brand_": "Marque",
  "modal_discover_more_": "D\xe9couvrir plus",
  "content_": "Contenu",
  "previous_searches_text_": "Vos recherches pr\xe9c\xe9dentes",
  "suggestions_": "Suggestions",
  "no_results_text_": "Aucun r\xe9sultat",
  "clear_filters_query_sorting_after_submit_": "Effacer la demande. Effacer aussi le tri et les filtres apr\xe8s le prochain envoi.",
  "placeholder_text_": "Rechercher",
  search_submit_button_aria_label_: "Rechercher",
  "search_field_field_aria_label_": "Champ de requ\xeate Rechercher",
  "previous_searches_delete_entry_from_history_": "Supprimer une requ\xeate de l\u2019historique",
  listing_suggestions_: "Cat\xe9gories & Collections",
  previous_: "Pr\xe9c\xe9dent",
  popular_: "Populaire",
  products_: "Produits",
  modal_view_all_no_results_: "Voir les alternatives"
};
const $c81467eae166ae22$var$german_base_translation = {
  "of_": "von",
  "sorting_text_": "Sortieren",
  "filter_text_": "Filtern",
  "filters_": "Filtern",
  "clear_all_from_filter_crumbs_": "Alle l\xf6schen",
  "clear_all_filters_from_big_button_": "Alle Filter l\xf6schen",
  "view_more_": "Mehr anzeigen",
  "view_less_": "Weniger anzeigen",
  "selected_filters_title_": "Filter",
  "try_without_filters_": "Versuche erneut ohne Filter",
  "clear_individual_filter_": "L\xf6schen",
  "range_filter_low_point_aria_label_": "Filterbereich niedrigster Wert",
  "range_filter_high_point_aria_label_": "Filterbereich h\xf6chster Wert",
  "morphing_sign_expanded_aria_label_": "Abschnitt einklappen",
  "morphing_sign_collapsed_aria_label_": "Abschnitt ausklappen",
  close_: "Schlie\xdfen",
  ok_: "OK",
  filters_cleared_: "Filter gel\xf6scht",
  we_cleared_your_filters_: "Wir haben die Filter gel\xf6scht",
  restore_: "Wiederherstellen",
  open_sorting_: "Sortierung \xf6ffnen",
  close_sorting_: "Sortierung schlie\xdfen",
  open_filters_: "Filter \xf6ffnen",
  close_filters_: "Filter schlie\xdfen",
  back_: "Zur\xfcck",
  scroll_to_top_: "Zum Anfang scrollen",
  breadcrumbs_aria_label_: "Brotkrumennavigation",
  search_a_filter_: section => "In \u201E".concat(section, "\u201C suchen")
};
const $c81467eae166ae22$export$f1905e1353ecf78e = {
  ...(0, $3ae9d5d3dda72bac$export$61b15fe6451cdba0),
  // fallbacks for untranslated strings
  ...$c81467eae166ae22$var$german_base_translation,
  show_n_products_: number_of_results => [number_of_results, " Produkte anzeigen"],
  "no_products_text_": "Keine Produkte hier, tut uns leid",
  product_: "Produkt",
  products_: "Produkte",
  quicklinks_aria_label_: "Kategorien"
};
const $c81467eae166ae22$export$b43a5e72c07b4d2a = {
  ...(0, $3ae9d5d3dda72bac$export$434b5d2e9cbbcde1),
  // fallbacks for untranslated strings
  ...$c81467eae166ae22$var$german_base_translation,
  show_n_results_: number_of_results => ["Zeige ", number_of_results, " Ergebnis(se)"],
  "search_recs_title_": "Du magst vielleicht auch",
  modal_view_all_results_: number_of_results => ["Alle ", number_of_results, " Ergebnis(se)"],
  "no_products_": "Keine Produkte gefunden",
  "no_results_text_": "Keine Ergebnisse",
  "previous_searches_text_": "Vorherige Suchanfragen",
  "content_": "Inhalt",
  "suggestions_": "Vorschl\xe4ge",
  "category_": "Kategori",
  "brand_": "Marke",
  "clear_filters_query_sorting_after_submit_": "Suchanfrage l\xf6schen. Sortierung und Filter nach dem n\xe4chsten Senden ebenfalls l\xf6schen.",
  "modal_discover_more_": "Mehr erforschen",
  search_submit_button_aria_label_: "Suchen",
  previous_searches_delete_entry_from_history_: "Anfrage aus Verlauf l\xf6schen",
  "search_field_field_aria_label_": "Suchanfragenfeld",
  "placeholder_text_": "Suchen",
  listing_suggestions_: "Kategorien & Kollektionen",
  previous_: "Vorherige",
  popular_: "Beliebt",
  products_: "Produkte",
  get_showing_results_for_: (query, number_of_results_element, has_query, number_of_results) => {
    const product_form = number_of_results === 1 ? "Produkt" : "Produkte";
    return has_query ? [number_of_results_element, " ".concat(product_form, " f\xfcr "), query] : ["Zeige alle ", number_of_results_element, " ".concat(product_form)];
  },
  get_showing_pages_for_: (query, number_of_results_element, has_query, number_of_results) => {
    const page_form = number_of_results === 1 ? "Seite" : "Seiten";
    return has_query ? [number_of_results_element, " ".concat(page_form, " f\xfcr "), query] : [number_of_results_element, " ".concat(page_form)];
  },
  modal_view_all_no_results_: "Alternativen anzeigen"
};
const $0e84ab0682b2b63b$var$italian_base_translation = {
  "of_": "di",
  "sorting_text_": "Ordina",
  "filter_text_": "Filtro",
  "filters_": "Filtri",
  "clear_all_from_filter_crumbs_": "Elimina tutto",
  "clear_all_filters_from_big_button_": "Elimina tutti i filtri",
  "view_more_": "Mostra di pi\xf9",
  "view_less_": "Mostra di meno",
  "selected_filters_title_": "Filtri",
  "try_without_filters_": "Riprova senza filtri",
  "clear_individual_filter_": "Elimina",
  "range_filter_low_point_aria_label_": "Valore inferiore del filtro di intervallo",
  "range_filter_high_point_aria_label_": "Valore superiore del filtro di intervallo",
  "morphing_sign_expanded_aria_label_": "Comprimi sezione",
  "morphing_sign_collapsed_aria_label_": "Espandi sezione",
  close_: "Chiudi",
  ok_: "OK",
  filters_cleared_: "Filtri cancellati",
  we_cleared_your_filters_: "Abbiamo cancellato i tuoi filtri",
  restore_: "Ripristina",
  open_sorting_: "Apri selezione",
  close_sorting_: "Chiudi selezione",
  open_filters_: "Apri filtri",
  close_filters_: "Chiudi filtri",
  back_: "Indietro",
  scroll_to_top_: "Scorri verso l'alto",
  "breadcrumbs_aria_label_": "Navigazione",
  search_a_filter_: section => "Cerca in \xab\xa0".concat(section, "\xa0\xbb")
};
const $0e84ab0682b2b63b$export$3812cbf78064c3ab = {
  ...(0, $3ae9d5d3dda72bac$export$61b15fe6451cdba0),
  // fallbacks for untranslated strings
  ...$0e84ab0682b2b63b$var$italian_base_translation,
  show_n_products_: number_of_results => ["Mostra ", number_of_results, " prodotti"],
  "no_products_text_": "Spiacenti, qui non ci sono prodotti",
  "product_": "prodotto",
  "products_": "prodotti",
  "quicklinks_aria_label_": "Categorie"
};
const $0e84ab0682b2b63b$export$c05550c0848a3fe4 = {
  ...(0, $3ae9d5d3dda72bac$export$434b5d2e9cbbcde1),
  // fallbacks for untranslated strings
  ...$0e84ab0682b2b63b$var$italian_base_translation,
  show_n_results_: number_of_results => ["Mostra ", number_of_results, " risultati"],
  modal_view_all_results_: number_of_results => ["Visualizza tutti i ", number_of_results, " risultati"],
  get_showing_results_for_: (query, number_of_results_element, has_query, number_of_results) => {
    const product_form = number_of_results === 1 ? "prodotto" : "prodotti";
    return has_query ? ["Visualizzazione di ", number_of_results_element, " ".concat(product_form, " per "), query] : ["Visualizzazione di tutti i ", number_of_results_element, " ".concat(product_form)];
  },
  get_showing_pages_for_: (query, number_of_results_element, has_query, number_of_results) => {
    const page_form = number_of_results === 1 ? "pagina" : "pagine";
    return has_query ? ["Trovato ", number_of_results_element, " ".concat(page_form, " per "), query] : ["Trovato ", number_of_results_element, " ".concat(page_form)];
  },
  "no_products_": "Nessun prodotto trovato",
  "content_": "Contenuto",
  "search_recs_title_": "Altre alternative",
  "category_": "Categoria",
  "brand_": "Marca",
  "modal_discover_more_": "Scopri di pi\xf9",
  "previous_searches_text_": "Le tue ricerche precedenti",
  "suggestions_": "Suggerimenti",
  "no_results_text_": "Nessun risultato",
  "clear_filters_query_sorting_after_submit_": "Cancella query. Cancella anche selezione e filtri dopo il prossimo invio.",
  "placeholder_text_": "Ricerca",
  search_submit_button_aria_label_: "Ricerca",
  "search_field_field_aria_label_": "Cerca campo query",
  "previous_searches_delete_entry_from_history_": "Rimuovi query dalla cronologia",
  listing_suggestions_: "Categorie & Collezioni",
  previous_: "Precedente",
  popular_: "Popolare",
  products_: "Prodotti",
  modal_view_all_no_results_: "Visualizza alternative"
};
const $38f06990a10567ed$var$norwegian_base_translation = {
  "of_": "av",
  "sorting_text_": "Sorter",
  "filter_text_": "Filter",
  "filters_": "Filtre",
  "clear_all_from_filter_crumbs_": "Fjern alt",
  "clear_all_filters_from_big_button_": "Fjern alle filtre",
  "view_more_": "Vis mer",
  "view_less_": "Vis mindre",
  "selected_filters_title_": "Filtere",
  "try_without_filters_": "Pr\xf8v igjen uten filtre",
  "clear_individual_filter_": "Fjern",
  range_filter_low_point_aria_label_: "Nedre verdi for omr\xe5defilter",
  range_filter_high_point_aria_label_: "\xd8vre verdi for omr\xe5defilter",
  morphing_sign_expanded_aria_label_: "Skjul del",
  morphing_sign_collapsed_aria_label_: "Utvid del",
  close_: "Lukk",
  ok_: "OK",
  filters_cleared_: "Filtrene er t\xf8mt",
  we_cleared_your_filters_: "Vi har t\xf8mt filtrene",
  restore_: "Gjenopprett",
  open_sorting_: "\xc5pne sortering",
  close_sorting_: "Lukk sortering",
  open_filters_: "\xc5pne filtre",
  close_filters_: "Lukk filtre",
  back_: "Tilbake",
  scroll_to_top_: "Rull til toppen",
  breadcrumbs_aria_label_: "Oversikt",
  search_a_filter_: section => "S\xf8k ".concat(section.toLowerCase())
};
const $38f06990a10567ed$export$e3024c30c728ef08 = {
  ...(0, $3ae9d5d3dda72bac$export$61b15fe6451cdba0),
  // fallbacks for untranslated strings
  ...$38f06990a10567ed$var$norwegian_base_translation,
  show_n_products_: number_of_results => ["Vis ", number_of_results, " produkter"],
  no_products_text_: "Ingen produkter her, beklager",
  product_: "produkt",
  products_: "produkter",
  quicklinks_aria_label_: "Kategorier"
};
const $38f06990a10567ed$export$dcb702a89633f297 = {
  ...(0, $3ae9d5d3dda72bac$export$434b5d2e9cbbcde1),
  // fallbacks for untranslated strings
  ...$38f06990a10567ed$var$norwegian_base_translation,
  show_n_results_: number_of_results => ["Vis ", number_of_results, " resultat(er)"],
  "clear_filters_query_sorting_after_submit_": "T\xf8m s\xf8kefeltet. T\xf8m ogs\xe5 sortering og filtrene etter neste innsending.",
  modal_view_all_results_: number_of_results => ["Vis alle ", number_of_results, " resultater"],
  "no_products_": "Ingen produkter funnet",
  "search_recs_title_": "Andre alternativer",
  "modal_discover_more_": "Oppdag mer",
  "category_": "Kategori",
  "brand_": "Merke",
  "suggestions_": "Forslag",
  "previous_searches_text_": "Tidligere s\xf8k",
  "content_": "Innhold",
  "no_results_text_": "Ingen resultater",
  "placeholder_text_": "S\xf8k",
  search_submit_button_aria_label_: "S\xf8k",
  "previous_searches_delete_entry_from_history_": "Slett sp\xf8rsm\xe5l fra loggen",
  "search_field_field_aria_label_": "S\xf8k sp\xf8rsm\xe5lfelt",
  listing_suggestions_: "Kategorier & Kolleksjoner",
  previous_: "Forrige",
  popular_: "Popul\xe6r",
  products_: "Produkter",
  get_showing_results_for_: (query, number_of_results_element, has_query, number_of_results) => {
    const product_form = number_of_results === 1 ? "produkt" : "produkter";
    return has_query ? ["Viser ", number_of_results_element, " ".concat(product_form, " for "), query] : ["Viser alle ", number_of_results_element, " ".concat(product_form)];
  },
  get_showing_pages_for_: (query, number_of_results_element, has_query, number_of_results) => {
    const page_form = number_of_results === 1 ? "side" : "sider";
    return has_query ? ["Fant ", number_of_results_element, " ".concat(page_form, " for "), query] : ["Fant ", number_of_results_element, " ".concat(page_form)];
  },
  modal_view_all_no_results_: "Vis alternativer"
};
const $101c0cfbaa775bb0$var$polish_base_translation = {
  "of_": "z",
  "sorting_text_": "Sortuj",
  "filter_text_": "Filtruj",
  "filters_": "Filtry",
  "clear_all_from_filter_crumbs_": "Wyczy\u015B\u0107 wszystkie",
  "clear_all_filters_from_big_button_": "Wyczy\u015B\u0107 wszystkie filtry",
  "view_more_": "Zobacz wi\u0119cej",
  "view_less_": "Zobacz mniej",
  "selected_filters_title_": "Filtry",
  "try_without_filters_": "Spr\xf3buj ponownie bez filtr\xf3w",
  "clear_individual_filter_": "Wyczy\u015B\u0107",
  "range_filter_low_point_aria_label_": "Dolna warto\u015B\u0107 filtra zakresu",
  "range_filter_high_point_aria_label_": "G\xf3rna warto\u015B\u0107 filtra zakresu",
  "morphing_sign_expanded_aria_label_": "Zwi\u0144 sekcj\u0119",
  "morphing_sign_collapsed_aria_label_": "Rozwi\u0144 sekcj\u0119",
  close_: "Zamknij",
  ok_: "OK",
  filters_cleared_: "Filtry wyczyszczone",
  we_cleared_your_filters_: "Wyczy\u015Bcili\u015Bmy twoje filtry",
  restore_: "Przywr\xf3\u0107",
  open_sorting_: "Otw\xf3rz sortowanie",
  close_sorting_: "Zamknij sortowanie",
  open_filters_: "Otw\xf3rz filtry",
  close_filters_: "Zamknij filtry",
  back_: "Wstecz",
  scroll_to_top_: "Przewi\u0144 do g\xf3ry",
  "breadcrumbs_aria_label_": "Nawigacja okruszkowa",
  search_a_filter_: section => "Szukaj ".concat(section.toLowerCase())
};
const $101c0cfbaa775bb0$export$ca594fc9015508ad = {
  ...(0, $3ae9d5d3dda72bac$export$61b15fe6451cdba0),
  // fallbacks for untranslated strings
  ...$101c0cfbaa775bb0$var$polish_base_translation,
  show_n_products_: number_of_results => ["Wy\u015Bwietl produkty: ", number_of_results],
  "no_products_text_": "Brak produkt\xf3w, przepraszamy",
  "product_": "produkt",
  "products_": "produkty/produkt\xf3w",
  "quicklinks_aria_label_": "Kategorie"
};
// jfc what's up with Polish?! Kudos to ChatGPT
const $101c0cfbaa775bb0$var$get_polish_form = (number, singular, few_form, many_form) => {
  if (number === undefined) return many_form;
  if (number === 1) return singular;
  const tens = number % 100;
  const units = number % 10;
  if (units >= 2 && units <= 4 && !(tens >= 12 && tens <= 14)) return few_form;
  return many_form;
};
const $101c0cfbaa775bb0$export$b0eb0dd41442f532 = {
  ...(0, $3ae9d5d3dda72bac$export$434b5d2e9cbbcde1),
  // fallbacks for untranslated strings
  ...$101c0cfbaa775bb0$var$polish_base_translation,
  show_n_results_: number_of_results => ["Wy\u015Bwietl wyniki: ", number_of_results],
  modal_view_all_results_: number_of_results => ["Zobacz wszystkie wyniki: ", number_of_results],
  get_showing_results_for_: (query, number_of_results_element, has_query, number_of_results) => {
    const product_form = $101c0cfbaa775bb0$var$get_polish_form(number_of_results, "produkt", "produkty", "produkt\xf3w");
    return has_query ? ["Wy\u015Bwietlanie ", number_of_results_element, " ".concat(product_form, " dla zapytania "), query] : ["Wy\u015Bwietlanie wszystkich produkt\xf3w: ", number_of_results_element];
  },
  get_showing_pages_for_: (query, number_of_results_element, has_query, number_of_results) => {
    const page_form = $101c0cfbaa775bb0$var$get_polish_form(number_of_results, "strona", "strony", "stron");
    return has_query ? ["Znaleziono ", number_of_results_element, " ".concat(page_form, " dla zapytania "), query] : ["Znaleziono ", number_of_results_element, " ".concat(page_form)];
  },
  "no_products_": "Nie znaleziono produkt\xf3w",
  "search_recs_title_": "Inne alternatywy",
  "category_": "Kategoria",
  "brand_": "Marka",
  "modal_discover_more_": "Zobacz wi\u0119cej",
  "previous_searches_text_": "Twoje poprzednie wyszukiwania",
  "suggestions_": "Sugestie",
  "no_results_text_": "Brak wynik\xf3w",
  "content_": "Tre\u015B\u0107",
  "clear_filters_query_sorting_after_submit_": "Wyczy\u015B\u0107 zapytanie. Wyczy\u015B\u0107 r\xf3wnie\u017C sortowanie i filtry po nast\u0119pnym przes\u0142aniu.",
  "placeholder_text_": "Wyszukaj",
  search_submit_button_aria_label_: "Wyszukaj",
  "search_field_field_aria_label_": "Pole wyszukiwania",
  "previous_searches_delete_entry_from_history_": "Usu\u0144 zapytanie z historii",
  listing_suggestions_: "Kategorie & Kolekcje",
  previous_: "Poprzedni",
  popular_: "Popularne",
  products_: "Produkty",
  modal_view_all_no_results_: "Zobacz alternatywy"
};
const $fd9d8e59d275df31$var$portuguese_base_translation = {
  "of_": "de",
  "sorting_text_": "Ordenar",
  "filter_text_": "Filtrar",
  "filters_": "Filtros",
  "clear_all_from_filter_crumbs_": "Limpar tudo",
  "clear_all_filters_from_big_button_": "Limpar todos os filtros",
  "view_more_": "Ver mais",
  "view_less_": "Ver menos",
  "selected_filters_title_": "Filtros",
  "try_without_filters_": "Voltar a tentar sem filtros",
  "clear_individual_filter_": "Limpar",
  "range_filter_low_point_aria_label_": "Filtro com valor mais baixo",
  "range_filter_high_point_aria_label_": "Filtro com valor mais alto",
  "morphing_sign_expanded_aria_label_": "Minimizar sec\xe7\xe3o",
  "morphing_sign_collapsed_aria_label_": "Expandir sec\xe7\xe3o",
  "breadcrumbs_aria_label_": "Trilhos",
  search_a_filter_: section => "Pesquisar em \xab\xa0".concat(section, "\xa0\xbb")
};
const $fd9d8e59d275df31$export$d8290cf1bac152ab = {
  ...(0, $3ae9d5d3dda72bac$export$61b15fe6451cdba0),
  // fallbacks for untranslated strings
  ...$fd9d8e59d275df31$var$portuguese_base_translation,
  show_n_products_: number_of_results => ["Mostrar ", number_of_results, " produtos"],
  "no_products_text_": "N\xe3o h\xe1 produtos aqui",
  "product_": "produto",
  "products_": "produtos",
  "quicklinks_aria_label_": "Categorias"
};
const $fd9d8e59d275df31$export$b3b5aa2c4df8976f = {
  ...(0, $3ae9d5d3dda72bac$export$434b5d2e9cbbcde1),
  // fallbacks for untranslated strings
  ...$fd9d8e59d275df31$var$portuguese_base_translation,
  show_n_results_: number_of_results => ["Mostar ", number_of_results, " resultado(s)"],
  modal_view_all_results_: number_of_results => ["Ver todos os ", number_of_results, " resultados"],
  get_showing_results_for_: (q, number_of_results_element, has_query, number_of_results) => {
    const singular = number_of_results === 1;
    return has_query ? ["A mostrar ", number_of_results_element, " produto".concat(singular ? "" : "s", " para "), q] : ["A mostrar todos os ", number_of_results_element, " produto".concat(singular ? "" : "s")];
  },
  get_showing_pages_for_: (q, number_of_results_element, has_query, number_of_results) => {
    const singular = number_of_results === 1;
    return has_query ? ["Encontrada".concat(singular ? "" : "s", " "), number_of_results_element, " p\xe1gina".concat(singular ? "" : "s", " para "), q] : ["Encontrada".concat(singular ? "" : "s", " "), number_of_results_element, " p\xe1gina".concat(singular ? "" : "s")];
  },
  "no_products_": "Nenhum produto encontrado",
  "content_": "Conte\xfado",
  "search_recs_title_": "Outras alternativas",
  "category_": "Categoria",
  "brand_": "Marca",
  "modal_discover_more_": "Descobrir mais",
  "previous_searches_text_": "As suas pesquisas anteriores",
  "suggestions_": "Sugest\xf5es",
  "no_results_text_": "Sem resultados",
  "clear_filters_query_sorting_after_submit_": "Limpar consulta. Limpar a sele\xe7\xe3o e os filtros depois do pr\xf3ximo envio.",
  "placeholder_text_": "Pesquisa",
  search_submit_button_aria_label_: "Pesquisa",
  "search_field_field_aria_label_": "Campo de consulta de pesquisa",
  "previous_searches_delete_entry_from_history_": "Remover consultas do hist\xf3rico",
  listing_suggestions_: "Categorias & Cole\xe7\xf5es",
  previous_: "Anterior",
  popular_: "Popular",
  products_: "Produtos",
  modal_view_all_no_results_: "Ver alternativas"
};
const $0c1ebd1a211aef29$var$spanish_base_translation = {
  "of_": "de",
  "sorting_text_": "Clasificar",
  "filter_text_": "Filtrar",
  "filters_": "Filtros",
  "clear_all_from_filter_crumbs_": "Limpiar todo",
  "clear_all_filters_from_big_button_": "Borrar todos los filtros",
  "view_more_": "Ver m\xe1s",
  "view_less_": "Ver menos",
  "selected_filters_title_": "Filtros",
  "try_without_filters_": "Int\xe9ntalo de nuevo sin filtros",
  "clear_individual_filter_": "Limpiar",
  "range_filter_low_point_aria_label_": "Valor m\xe1s bajo del filtro de rango",
  "range_filter_high_point_aria_label_": "Valor m\xe1s alto del filtro de rango",
  "morphing_sign_expanded_aria_label_": "Contraer secci\xf3n",
  "morphing_sign_collapsed_aria_label_": "Ampliar secci\xf3n",
  close_: "Cerrar",
  ok_: "OK",
  filters_cleared_: "Filtros borrados",
  we_cleared_your_filters_: "Hemos borrado los filtros",
  restore_: "Restaurar",
  open_sorting_: "Abrir clasificaci\xf3n",
  close_sorting_: "Cerrar clasificaci\xf3n",
  open_filters_: "Abrir filtros",
  close_filters_: "Cerrar filtros",
  back_: "Atr\xe1s",
  scroll_to_top_: "Ir al principio",
  "breadcrumbs_aria_label_": "Rastro",
  search_a_filter_: section => "Buscar en \xab\xa0".concat(section, "\xa0\xbb")
};
const $0c1ebd1a211aef29$export$40e5a8a77e52bc27 = {
  ...(0, $3ae9d5d3dda72bac$export$61b15fe6451cdba0),
  // fallbacks for untranslated strings
  ...$0c1ebd1a211aef29$var$spanish_base_translation,
  show_n_products_: number_of_results => ["Mostrar ", number_of_results, " productos"],
  "no_products_text_": "No hay productos aqu\xed, lo siento",
  "product_": "producto",
  "products_": "productos",
  "quicklinks_aria_label_": "Categor\xedas"
};
const $0c1ebd1a211aef29$export$49b8f20513f0ff25 = {
  ...(0, $3ae9d5d3dda72bac$export$434b5d2e9cbbcde1),
  // fallbacks for untranslated strings
  ...$0c1ebd1a211aef29$var$spanish_base_translation,
  show_n_results_: number_of_results => ["Mostrar ", number_of_results, " resultado/s"],
  modal_view_all_results_: number_of_results => ["Ver todos los ", number_of_results, " resultados"],
  get_showing_results_for_: (q, number_of_results_element, has_query, number_of_results) => {
    const singular = number_of_results === 1;
    return has_query ? ["Mostrando ", number_of_results_element, " producto".concat(singular ? "" : "s", " para "), q] : ["Mostrando todos los ", number_of_results_element, " producto".concat(singular ? "" : "s")];
  },
  get_showing_pages_for_: (q, number_of_results_element, has_query, number_of_results) => {
    const singular = number_of_results === 1;
    return has_query ? ["Encontrado".concat(singular ? "" : "s", " "), number_of_results_element, " p\xe1gina".concat(singular ? "" : "s", " para "), q] : ["Encontrado".concat(singular ? "" : "s", " "), number_of_results_element, " p\xe1gina".concat(singular ? "" : "s")];
  },
  "search_recs_title_": "Otras alternativas",
  "category_": "Categor\xeda",
  "content_": "Contenido",
  "no_products_": "No se encontraron productos",
  "brand_": "Marca",
  "modal_discover_more_": "Descubrir m\xe1s",
  "previous_searches_text_": "Tus b\xfasquedas anteriores",
  "suggestions_": "Sugerencias",
  "no_results_text_": "No hay resultados",
  "clear_filters_query_sorting_after_submit_": "Borrar consulta. Eliminar tambi\xe9n la selecci\xf3n y los filtros despu\xe9s del pr\xf3ximo env\xedo.",
  "placeholder_text_": "B\xfasqueda",
  search_submit_button_aria_label_: "B\xfasqueda",
  "search_field_field_aria_label_": "Campo de consulta de b\xfasqueda",
  "previous_searches_delete_entry_from_history_": "Eliminar consulta del historial",
  listing_suggestions_: "Categor\xedas & Colecciones",
  previous_: "Anterior",
  popular_: "Popular",
  products_: "Productos",
  modal_view_all_no_results_: "Ver alternativas"
};
const $47640445b8596ffd$var$swedish_base_translation = {
  "of_": "av",
  // 50 of 120
  "sorting_text_": "Sortera",
  "filter_text_": "Filtrera",
  "filters_": "Filtrera",
  "clear_all_from_filter_crumbs_": "Rensa alla",
  "clear_all_filters_from_big_button_": "Rensa alla filter",
  "view_more_": "Visa fler",
  "view_less_": "Visa f\xe4rre",
  "selected_filters_title_": "Filter",
  "try_without_filters_": "Prova igen utan filter",
  "clear_individual_filter_": "Rensa",
  range_filter_low_point_aria_label_: "Intervallfilter fr\xe5n v\xe4rde",
  range_filter_high_point_aria_label_: "Intervallfilter till v\xe4rde",
  morphing_sign_expanded_aria_label_: "F\xe4ll ihop sektion",
  morphing_sign_collapsed_aria_label_: "Expandera sektion",
  close_: "St\xe4ng",
  ok_: "OK",
  filters_cleared_: "Filter rensade",
  we_cleared_your_filters_: "Vi rensade dina filter",
  restore_: "\xc5terst\xe4ll",
  open_sorting_: "\xd6ppna sortering",
  close_sorting_: "St\xe4ng sortering",
  open_filters_: "\xd6ppna filter",
  close_filters_: "St\xe4ng filter",
  back_: "Tillbaka",
  scroll_to_top_: "Scrolla upp",
  breadcrumbs_aria_label_: "L\xe4nkkedja",
  search_a_filter_: section => "S\xf6k ".concat(section.toLowerCase())
};
const $47640445b8596ffd$export$7ba4dc17618f444f = {
  ...(0, $3ae9d5d3dda72bac$export$61b15fe6451cdba0),
  // fallbacks for untranslated strings
  ...$47640445b8596ffd$var$swedish_base_translation,
  show_n_products_: number_of_results => ["Visa ", number_of_results, " produkter"],
  no_products_text_: "Inga produkter h\xe4r, tyv\xe4rr",
  product_: "produkt",
  products_: "produkter",
  quicklinks_aria_label_: "Kategorier"
};
const $47640445b8596ffd$export$596caee559c76764 = {
  ...(0, $3ae9d5d3dda72bac$export$434b5d2e9cbbcde1),
  // fallbacks for untranslated strings
  ...$47640445b8596ffd$var$swedish_base_translation,
  "no_results_text_": "Inga resultat",
  modal_view_all_results_: number_of_results => ["Visa alla ", number_of_results, " resultat"],
  modal_view_all_no_results_: "Visa andra alternativ",
  "search_recs_title_": "Andra alternativ",
  "clear_filters_query_sorting_after_submit_": "Rensa f\xf6rfr\xe5ga och filter + sorting efter ny f\xf6rfr\xe5ga",
  "previous_searches_text_": "Dina tidigare s\xf6kningar",
  "category_": "Kategori",
  "brand_": "Varum\xe4rke",
  "suggestions_": "F\xf6rslag",
  "modal_discover_more_": "Utforska mer",
  "placeholder_text_": "S\xf6k",
  "content_": "Inneh\xe5ll",
  "no_products_": "Inga produkter hittades",
  search_submit_button_aria_label_: "S\xf6k",
  search_field_field_aria_label_: "S\xf6kf\xe4lt",
  previous_searches_delete_entry_from_history_: "Rensa alla",
  listing_suggestions_: "Kategorier & Kollektioner",
  previous_: "Tidigare",
  popular_: "Popul\xe4ra",
  products_: "Produkter",
  get_showing_results_for_: (q, number_of_results_element, has_query, number_of_results) => {
    const singular = number_of_results === 1;
    return has_query ? ["Visar ", number_of_results_element, " produkt".concat(singular ? "" : "er", " f\xf6r "), q] : ["Visar samtliga ", number_of_results_element, " produkt".concat(singular ? "" : "er")];
  },
  get_showing_pages_for_: (q, number_of_results_element, has_query, number_of_results) => {
    const singular = number_of_results === 1;
    return has_query ? ["Hittade ", number_of_results_element, " sid".concat(singular ? "a" : "or", " f\xf6r "), q] : ["Hittade ", number_of_results_element, " sid".concat(singular ? "a" : "or")];
  },
  show_n_results_: number_of_results => ["Visa ", number_of_results, " resultat"]
};
const $72b32e7f8dfbdf34$export$67ff43e65e668f2b = {
  ...(0, $6364f832d4df5198$export$93916862db74da11),
  ...(0, $6364f832d4df5198$export$62ef558576ddaf3d),
  backend_locale_: "cz"
};
const $72b32e7f8dfbdf34$export$8c8450b83b664ba4 = {
  ...(0, $d73851348ade03e4$export$f816e22bdb8038e1),
  ...(0, $d73851348ade03e4$export$70578856b2420b5d),
  backend_locale_: "da"
};
const $72b32e7f8dfbdf34$export$6de2d8c8de3011d9 = {
  ...(0, $d73851348ade03e4$export$f816e22bdb8038e1),
  ...(0, $d73851348ade03e4$export$70578856b2420b5d),
  backend_locale_: "da_DK"
};
const $72b32e7f8dfbdf34$export$9c64ee4d84d79ce1 = {
  ...(0, $368410baba881db8$export$e6614b50d36f30aa),
  ...(0, $368410baba881db8$export$5d14584e27bf4bc5),
  backend_locale_: "nl"
};
const $72b32e7f8dfbdf34$export$56f6972fd618655a = {
  ...(0, $368410baba881db8$export$e6614b50d36f30aa),
  ...(0, $368410baba881db8$export$5d14584e27bf4bc5),
  backend_locale_: "nl_BE"
};
const $72b32e7f8dfbdf34$export$ecbd6264f248e614 = {
  ...(0, $368410baba881db8$export$e6614b50d36f30aa),
  ...(0, $368410baba881db8$export$5d14584e27bf4bc5),
  backend_locale_: "nl_NL"
};
const $72b32e7f8dfbdf34$export$84584c2a98eb6753 = {
  ...(0, $3ae9d5d3dda72bac$export$61b15fe6451cdba0),
  ...(0, $3ae9d5d3dda72bac$export$434b5d2e9cbbcde1),
  backend_locale_: "en"
};
const $72b32e7f8dfbdf34$export$c8af9ccf06a8b16a = {
  ...(0, $3ae9d5d3dda72bac$export$61b15fe6451cdba0),
  ...(0, $3ae9d5d3dda72bac$export$434b5d2e9cbbcde1),
  backend_locale_: "en_AU"
};
const $72b32e7f8dfbdf34$export$a2bced10ed717c1f = {
  ...(0, $3ae9d5d3dda72bac$export$61b15fe6451cdba0),
  ...(0, $3ae9d5d3dda72bac$export$434b5d2e9cbbcde1),
  backend_locale_: "en_CA"
};
const $72b32e7f8dfbdf34$export$6ac7ea553f9cecc6 = {
  ...(0, $3ae9d5d3dda72bac$export$61b15fe6451cdba0),
  ...(0, $3ae9d5d3dda72bac$export$434b5d2e9cbbcde1),
  backend_locale_: "en_EU"
};
const $72b32e7f8dfbdf34$export$b76508d27899e649 = {
  ...(0, $3ae9d5d3dda72bac$export$61b15fe6451cdba0),
  ...(0, $3ae9d5d3dda72bac$export$434b5d2e9cbbcde1),
  backend_locale_: "en_GB"
};
const $72b32e7f8dfbdf34$export$df031397bb44d506 = {
  ...(0, $3ae9d5d3dda72bac$export$61b15fe6451cdba0),
  ...(0, $3ae9d5d3dda72bac$export$434b5d2e9cbbcde1),
  backend_locale_: "en_IE"
};
const $72b32e7f8dfbdf34$export$25dc44e90bc68e13 = {
  ...(0, $3ae9d5d3dda72bac$export$61b15fe6451cdba0),
  ...(0, $3ae9d5d3dda72bac$export$434b5d2e9cbbcde1),
  backend_locale_: "en_US"
};
const $72b32e7f8dfbdf34$export$ed5179c818622fb = {
  ...(0, $5140cb4dc78a083c$export$bf7930000f7ad633),
  ...(0, $5140cb4dc78a083c$export$bb9c5e11b9203620),
  backend_locale_: "fi"
};
const $72b32e7f8dfbdf34$export$beb170d4da98ae91 = {
  ...(0, $5140cb4dc78a083c$export$bf7930000f7ad633),
  ...(0, $5140cb4dc78a083c$export$bb9c5e11b9203620),
  backend_locale_: "fi_FI"
};
const $72b32e7f8dfbdf34$export$acb2a88f7d552ebf = {
  ...(0, $4696ad1afe2a2ee4$export$ef75fbff2e809c9),
  ...(0, $4696ad1afe2a2ee4$export$e608b2bb21ba1862),
  backend_locale_: "fr"
};
const $72b32e7f8dfbdf34$export$30f960919adb1a48 = {
  ...(0, $4696ad1afe2a2ee4$export$ef75fbff2e809c9),
  ...(0, $4696ad1afe2a2ee4$export$e608b2bb21ba1862),
  backend_locale_: "fr_FR"
};
const $72b32e7f8dfbdf34$export$83201021df913d35 = {
  ...(0, $4696ad1afe2a2ee4$export$ef75fbff2e809c9),
  ...(0, $4696ad1afe2a2ee4$export$e608b2bb21ba1862),
  backend_locale_: "fr_CA"
};
const $72b32e7f8dfbdf34$export$2fa162a495d26869 = {
  ...(0, $c81467eae166ae22$export$f1905e1353ecf78e),
  ...(0, $c81467eae166ae22$export$b43a5e72c07b4d2a),
  backend_locale_: "de"
};
const $72b32e7f8dfbdf34$export$cdfc1e873a859e64 = {
  ...(0, $c81467eae166ae22$export$f1905e1353ecf78e),
  ...(0, $c81467eae166ae22$export$b43a5e72c07b4d2a),
  backend_locale_: "de_AT"
};
const $72b32e7f8dfbdf34$export$24592eff4b41c0d = {
  ...(0, $c81467eae166ae22$export$f1905e1353ecf78e),
  ...(0, $c81467eae166ae22$export$b43a5e72c07b4d2a),
  backend_locale_: "de_CH"
};
const $72b32e7f8dfbdf34$export$5d6cddfc629f77eb = {
  ...(0, $c81467eae166ae22$export$f1905e1353ecf78e),
  ...(0, $c81467eae166ae22$export$b43a5e72c07b4d2a),
  backend_locale_: "de_DE"
};
const $72b32e7f8dfbdf34$export$3486a10f30cf1ee4 = {
  ...(0, $0e84ab0682b2b63b$export$3812cbf78064c3ab),
  ...(0, $0e84ab0682b2b63b$export$c05550c0848a3fe4),
  backend_locale_: "it"
};
const $72b32e7f8dfbdf34$export$f9b5ea3bf81395b7 = {
  ...(0, $0e84ab0682b2b63b$export$3812cbf78064c3ab),
  ...(0, $0e84ab0682b2b63b$export$c05550c0848a3fe4),
  backend_locale_: "it_IT"
};
const $72b32e7f8dfbdf34$export$401451a107dc42ce = {
  ...(0, $38f06990a10567ed$export$e3024c30c728ef08),
  ...(0, $38f06990a10567ed$export$dcb702a89633f297),
  backend_locale_: "no"
};
const $72b32e7f8dfbdf34$export$9493b74ae2e265b1 = {
  ...(0, $38f06990a10567ed$export$e3024c30c728ef08),
  ...(0, $38f06990a10567ed$export$dcb702a89633f297),
  backend_locale_: "nb_NO"
};
const $72b32e7f8dfbdf34$export$38ef0e3f791a121e = {
  ...(0, $38f06990a10567ed$export$e3024c30c728ef08),
  ...(0, $38f06990a10567ed$export$dcb702a89633f297),
  backend_locale_: "nb"
};
const $72b32e7f8dfbdf34$export$f096898031724516 = {
  ...(0, $38f06990a10567ed$export$e3024c30c728ef08),
  ...(0, $38f06990a10567ed$export$dcb702a89633f297),
  backend_locale_: "no_NO"
};
const $72b32e7f8dfbdf34$export$6ea5311eda92944f = {
  ...(0, $101c0cfbaa775bb0$export$ca594fc9015508ad),
  ...(0, $101c0cfbaa775bb0$export$b0eb0dd41442f532),
  backend_locale_: "pl"
};
const $72b32e7f8dfbdf34$export$cac2311efb6f04b1 = {
  ...(0, $101c0cfbaa775bb0$export$ca594fc9015508ad),
  ...(0, $101c0cfbaa775bb0$export$b0eb0dd41442f532),
  backend_locale_: "pl_PL"
};
const $72b32e7f8dfbdf34$export$84175d5f1cb4e39d = {
  ...(0, $fd9d8e59d275df31$export$d8290cf1bac152ab),
  ...(0, $fd9d8e59d275df31$export$b3b5aa2c4df8976f),
  backend_locale_: "pt"
};
const $72b32e7f8dfbdf34$export$ca5e4045a55e76d2 = {
  ...(0, $0c1ebd1a211aef29$export$40e5a8a77e52bc27),
  ...(0, $0c1ebd1a211aef29$export$49b8f20513f0ff25),
  backend_locale_: "es"
};
const $72b32e7f8dfbdf34$export$97f82aee9c1ce125 = {
  ...(0, $0c1ebd1a211aef29$export$40e5a8a77e52bc27),
  ...(0, $0c1ebd1a211aef29$export$49b8f20513f0ff25),
  backend_locale_: "es_ES"
};
const $72b32e7f8dfbdf34$export$65540e5f7f6e7dce = {
  ...(0, $47640445b8596ffd$export$7ba4dc17618f444f),
  ...(0, $47640445b8596ffd$export$596caee559c76764),
  backend_locale_: "sv"
};
const $72b32e7f8dfbdf34$export$c395d7caf3689a53 = {
  ...(0, $47640445b8596ffd$export$7ba4dc17618f444f),
  ...(0, $47640445b8596ffd$export$596caee559c76764),
  backend_locale_: "sv_SE"
};
const $72b32e7f8dfbdf34$export$d7f512c98c859244 = $72b32e7f8dfbdf34$export$84584c2a98eb6753;
export { $72b32e7f8dfbdf34$export$67ff43e65e668f2b as cz, $72b32e7f8dfbdf34$export$8c8450b83b664ba4 as da, $72b32e7f8dfbdf34$export$6de2d8c8de3011d9 as da_DK, $72b32e7f8dfbdf34$export$9c64ee4d84d79ce1 as nl, $72b32e7f8dfbdf34$export$56f6972fd618655a as nl_BE, $72b32e7f8dfbdf34$export$ecbd6264f248e614 as nl_NL, $72b32e7f8dfbdf34$export$84584c2a98eb6753 as en, $72b32e7f8dfbdf34$export$c8af9ccf06a8b16a as en_AU, $72b32e7f8dfbdf34$export$a2bced10ed717c1f as en_CA, $72b32e7f8dfbdf34$export$6ac7ea553f9cecc6 as en_EU, $72b32e7f8dfbdf34$export$b76508d27899e649 as en_GB, $72b32e7f8dfbdf34$export$df031397bb44d506 as en_IE, $72b32e7f8dfbdf34$export$25dc44e90bc68e13 as en_US, $72b32e7f8dfbdf34$export$ed5179c818622fb as fi, $72b32e7f8dfbdf34$export$beb170d4da98ae91 as fi_FI, $72b32e7f8dfbdf34$export$acb2a88f7d552ebf as fr, $72b32e7f8dfbdf34$export$30f960919adb1a48 as fr_FR, $72b32e7f8dfbdf34$export$83201021df913d35 as fr_CA, $72b32e7f8dfbdf34$export$2fa162a495d26869 as de, $72b32e7f8dfbdf34$export$cdfc1e873a859e64 as de_AT, $72b32e7f8dfbdf34$export$24592eff4b41c0d as de_CH, $72b32e7f8dfbdf34$export$5d6cddfc629f77eb as de_DE, $72b32e7f8dfbdf34$export$3486a10f30cf1ee4 as it, $72b32e7f8dfbdf34$export$f9b5ea3bf81395b7 as it_IT, $72b32e7f8dfbdf34$export$401451a107dc42ce as no, $72b32e7f8dfbdf34$export$9493b74ae2e265b1 as nb_NO, $72b32e7f8dfbdf34$export$38ef0e3f791a121e as nb, $72b32e7f8dfbdf34$export$f096898031724516 as no_NO, $72b32e7f8dfbdf34$export$6ea5311eda92944f as pl, $72b32e7f8dfbdf34$export$cac2311efb6f04b1 as pl_PL, $72b32e7f8dfbdf34$export$84175d5f1cb4e39d as pt, $72b32e7f8dfbdf34$export$ca5e4045a55e76d2 as es, $72b32e7f8dfbdf34$export$97f82aee9c1ce125 as es_ES, $72b32e7f8dfbdf34$export$65540e5f7f6e7dce as sv, $72b32e7f8dfbdf34$export$c395d7caf3689a53 as sv_SE, $72b32e7f8dfbdf34$export$d7f512c98c859244 as defaultLocale };